module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "loading-ellipsis"
  }, [_c('span', {
    staticClass: "one"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "two"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "three"
  }, [_vm._v(".")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-7216666a"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/HeadingLoading.vue
// module id = 1037
// module chunks = 0